module.exports = __webpack_public_path__ + "static/media/opintrack-icon.a9bbb726.svg";